<!-- Start Main Banner Area -->
<div class="main-banner">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container-fluid">
                <div class="row align-items-center">
                    <div class="col-lg-6 col-md-12">
                        <div class="main-banner-content">
                            <span>Smart Solar Solutions</span>
                            <h1>Power Your Future with Solar Energy.</h1>
                            <p>Reduce your electricity bills and embrace clean, reliable energy with
                                <strong>SolarCiti</strong>. We
                                provide customized residential, commercial, and industrial solar solutions designed to
                                maximize savings and deliver sustainable energy for years to come.
                            </p>
                            <a routerLink="/contact" style="margin-top: 30px;" class="btn btn-primary">
                                Get Started
                            </a>
                        </div>
                    </div>

                    <div class="col-lg-6 col-md-12">
                        <div class="main-banner-image">
                            <img src="assets/image/banner.png" alt="image">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="banner-shape"><img src="assets/img/white-shape.png" alt="image"></div>
    <div class="shape1"><img src="assets/img/shape/2.png" alt="image"></div>
    <div class="shape2"><img src="assets/img/shape/3.png" alt="image"></div>
</div>
<!-- End Main Banner Area -->

<!-- Start Partner Area -->
<div class="partner-area">
    <div class="container">
        <div class="partner-slides owl-carousel owl-theme">
            <div class="single-partner-item">
                <a href="#"><img src="assets/image/client1.jpeg" alt="image"></a>
            </div>
            <div class="single-partner-item">
                <a href="#"><img src="assets/image/client2.jpeg" alt="image"></a>
            </div>
            <div class="single-partner-item">
                <a href="#"><img src="assets/image/client3.jpeg" alt="image"></a>
            </div>
            <div class="single-partner-item">
                <a href="#"><img src="assets/image/client4.png" alt="image"></a>
            </div>
            <div class="single-partner-item">
                <a href="#"><img src="assets/image/client5.png" alt="image"></a>
            </div>
             <div class="single-partner-item">
                <a href="#"><img src="assets/image/client6.png" alt="image"></a>
            </div>
        </div>
    </div>
</div>
<!-- End Partner Area -->

<!-- Start Featured Solutions Area -->
<section class="featured-solutions-area ptb-110">
    <div class="container">
        <div class="section-title">
            <h2>Our Solar Solutions</h2>
            <p>Choose the right solar system for your energy needs and enjoy reliable, efficient, and cost-effective
                clean energy.</p>
        </div>

        <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-featured-solutions">
                    <img src="assets/image/on-grid.png" alt="On-Grid Solar System">

                    <h3>On-Grid Solar System</h3>
                    <p>Generate clean solar energy and reduce your electricity bills with a grid-connected solar system
                        designed for homes and businesses.</p>
                    <a routerLink="/on-grid" class="read-more-btn">Read More <i class="flaticon-add"></i></a>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-featured-solutions">
                    <img src="assets/image/off-grid.png" alt="Off-Grid Solar System">

                    <h3>Off-Grid Solar System</h3>
                    <p>Enjoy greater energy independence with an off-grid solar solution that uses battery storage to
                        provide power even without the grid.</p>
                    <a routerLink="off-grid" class="read-more-btn">Read More <i class="flaticon-add"></i></a>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6 offset-lg-0 offset-md-3 offset-sm-3">
                <div class="single-featured-solutions">
                    <img src="assets/image/hybrid.png" alt="Hybrid Solar System">

                    <h3>Hybrid Solar System</h3>
                    <p>Get the best of solar power and battery backup with a hybrid system built for energy savings
                        and uninterrupted power.</p>
                    <a routerLink="/hybrid" class="read-more-btn">Read More <i class="flaticon-add"></i></a>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Featured Solutions Area -->

<!-- Start Features Area -->
<section class="features-area ptb-110 bg-f7f9fc">
    <div class="container">
        <div class="overview-box">
            <div class="image wow zoomIn" data-wow-delay="1s">
                <img src="assets/image/banner4.png" alt="Solar Energy Solutions">
            </div>

            <div class="content">
                <h3>Power your home and business with clean solar energy.</h3>
                <p>
                    <strong>SolarCiti</strong> provides reliable and customized solar solutions designed
                    to reduce electricity costs, improve energy efficiency, and help you
                    move towards a cleaner and more sustainable future.
                </p>

                <ul class="features-list">
                    <li><span><i class='bx bx-check-double'></i> Reduce Electricity Bills</span></li>
                    <li><span><i class='bx bx-check-double'></i> Customized Solar Solutions</span></li>
                    <li><span><i class='bx bx-check-double'></i> Reliable & Efficient Systems</span></li>
                    <li><span><i class='bx bx-check-double'></i> Clean & Sustainable Energy</span></li>
                </ul>
            </div>
        </div>

        <div class="overview-box">
            <div class="content">
                <h3>From solar design to installation, we've got you covered.</h3>
                <p>
                    From site inspection and system sizing to installation, commissioning,
                    subsidy assistance, and ongoing maintenance, <strong>SolarCiti</strong> makes your
                    transition to solar simple and hassle-free.
                </p>

                <ul class="features-list">
                    <li><span><i class='bx bx-check-double'></i> Expert Consultation & System Sizing</span></li>
                    <li><span><i class='bx bx-check-double'></i> Professional Installation</span></li>
                    <li><span><i class='bx bx-check-double'></i> Subsidy & Net-Metering Support</span></li>
                    <li><span><i class='bx bx-check-double'></i> Post-Installation Support</span></li>
                </ul>
            </div>

            <div class="image wow zoomIn" data-wow-delay="1s">
                <img src="assets/image/banner3.png" alt="Solar Installation Services">
            </div>
        </div>
    </div>

    <div class="rectangle-shape1">
        <img src="assets/img/rectangle-shape1.png" alt="image">
    </div>

    <div class="rectangle-shape2">
        <img src="assets/img/rectangle-shape2.png" alt="image">
    </div>
</section>
<!-- End Features Area -->

<app-funfact></app-funfact>

<app-solar-calculator></app-solar-calculator>
<!-- Start Services Area -->
<section class="services-area ptb-110 bg-fafafa pb-0">
    <div class="container">
        <div class="section-title">
            <h2>Complete Solar Solutions for Every Need</h2>
            <p>
                From rooftop installation to maintenance and monitoring, <strong>SolarCiti</strong>
                provides reliable solar solutions designed for homes, businesses,
                and industries.
            </p>
        </div>

        <div class="row">

            <!-- Residential Solar -->
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-services-box">
                    <div class="icon">
                        <img src="assets/image/user1.jpeg" alt="Residential Solar">
                    </div>
                    <h3><a >Residential Solar</a></h3>
                    <p>
                        Power your home with clean solar energy and reduce your
                        monthly electricity bills with a customized rooftop solar system.
                    </p>
                </div>
            </div>

            <!-- Commercial & Industrial -->
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-services-box">
                    <div class="icon">
                        <img src="assets/image/industrial.png" alt="Commercial and Industrial Solar">
                    </div>
                    <h3><a >Commercial &amp; Industrial Solar</a></h3>
                    <p>
                        Customized solar solutions for businesses, factories,
                        warehouses, and commercial facilities to improve energy efficiency
                        and reduce operating costs.
                    </p>
                </div>
            </div>

            <!-- On-Grid Solar -->
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-services-box">
                    <div class="icon">
                        <img src="assets/image/solar1.png" alt="On-Grid Solar System">
                    </div>
                    <h3><a >On-Grid Solar Systems</a></h3>
                    <p>
                        Generate your own electricity with a grid-connected solar
                        system and maximize savings through efficient solar power generation.
                    </p>
                </div>
            </div>

            <!-- Off-Grid Solar -->
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-services-box">
                    <div class="icon">
                        <img src="assets/image/solar2.png" alt="Off-Grid Solar System">
                    </div>
                    <h3><a >Off-Grid Solar Systems</a></h3>
                    <p>
                        Enjoy greater energy independence with solar systems supported
                        by battery storage for reliable power when grid electricity is unavailable.
                    </p>
                </div>
            </div>

            <!-- Hybrid Solar -->
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-services-box">
                    <div class="icon">
                        <img src="assets/image/hybrid1.png" alt="Hybrid Solar System">
                    </div>
                    <h3><a>Hybrid Solar Systems</a></h3>
                    <p>
                        Combine solar generation, grid power, and battery storage
                        for greater flexibility, energy savings, and reliable backup power.
                    </p>
                </div>
            </div>

            <!-- Solar Maintenance -->
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-services-box">
                    <div class="icon">
                        <img src="assets/image/cleaning.png" alt="Solar Maintenance">
                    </div>
                    <h3><a >Solar Maintenance &amp; AMC</a></h3>
                    <p>
                        Keep your solar system performing efficiently with regular
                        maintenance, panel cleaning, preventive care, and performance monitoring.
                    </p>
                </div>
            </div>

        </div>
    </div>

    <div class="services-shape">
        <img src="assets/img/services-shape.png" alt="image">
    </div>
</section>
<!-- End Services Area -->

<app-feedback></app-feedback>

<!-- Start Serve Area -->
<section class="serve-area ptb-110">
    <div class="container">
        <div class="section-title">
            <h2>Who We Serve</h2>
            <p>
                <strong>SolarCiti</strong> delivers customized solar energy solutions for homes,
                businesses, industries, and institutions looking to reduce energy
                costs and switch to clean, sustainable power.
            </p>
        </div>

        <div class="row">

            <div class="col-lg-3 col-md-4 col-sm-6">
                <div class="single-serve-box">
                    <i class="flaticon-house"></i>
                    <h3>Residential</h3>
                  
                </div>
            </div>

            <div class="col-lg-3 col-md-4 col-sm-6">
                <div class="single-serve-box">
                    <i class="flaticon-factory"></i>
                    <h3>Manufacturing</h3>
                   
                </div>
            </div>

            <div class="col-lg-3 col-md-4 col-sm-6">
                <div class="single-serve-box">
                    <i class="flaticon-box"></i>
                    <h3>Warehouses</h3>
                    
                </div>
            </div>

            <div class="col-lg-3 col-md-4 col-sm-6">
                <div class="single-serve-box">
                    <i class="flaticon-hospital"></i>
                    <h3>Healthcare</h3>
                   
                </div>
            </div>

            <div class="col-lg-3 col-md-4 col-sm-6">
                <div class="single-serve-box">
                    <i class="flaticon-house"></i>
                    <h3>Commercial Buildings</h3>
                    
                </div>
            </div>

            <div class="col-lg-3 col-md-4 col-sm-6">
                <div class="single-serve-box">
                    <i class="flaticon-money-bag"></i>
                    <h3>Offices &amp; Businesses</h3>
                   
                </div>
            </div>

            <div class="col-lg-3 col-md-4 col-sm-6">
                <div class="single-serve-box">
                    <i class="flaticon-tracking"></i>
                    <h3>Educational Institutions</h3>
                   
                </div>
            </div>

            <div class="col-lg-3 col-md-4 col-sm-6">
                <div class="single-serve-box">
                    <i class="flaticon-insurance"></i>
                    <h3>Industrial <br> Facilities</h3>
                   
                </div>
            </div>

        </div>
    </div>
</section>
<!-- End Serve Area -->

<!-- Start Blog Area -->
<section class="blog-area ptb-110 bg-f9f9f9">
    <div class="container">

        <div class="section-title">
            <span>Solar Insights</span>

            <h2>Our Latest Solar Stories</h2>

            <p>
                Explore practical solar insights, system guides, energy-saving
                tips, and information to help you make smarter solar decisions.
            </p>
        </div>


        <div class="row">

            <div class="col-lg-4 col-md-6" *ngFor="let blog of blogs">

                <div class="single-blog-post">

                    <!-- Image -->
                    <div class="entry-thumbnail">

                        <a [routerLink]="['/blog', blog.id]">

                            <img [src]="blog.image" [alt]="blog.title">

                        </a>

                    </div>


                    <!-- Content -->
                    <div class="entry-post-content">

                        <div class="entry-meta">

                            <ul>

                                <li>
                                    <a href="javascript:void(0)">
                                        {{ blog.category }}
                                    </a>
                                </li>

                                <li>
                                    {{ blog.date }}
                                </li>

                            </ul>

                        </div>


                        <h3>

                            <a [routerLink]="['/blog', blog.id]">
                                {{ blog.title }}
                            </a>

                        </h3>


                        <p>
                            {{ blog.shortDescription }}
                        </p>


                        <a [routerLink]="['/blog', blog.id]" class="read-more-btn">

                            Read More

                            <i class="flaticon-add-1"></i>

                        </a>

                    </div>

                </div>

            </div>

        </div>

    </div>
</section>
<!-- End Blog Area -->
<!-- End Blog Area -->

<!-- <app-subscribe></app-subscribe> -->
<app-faq></app-faq>